import script from "./SingleChart.vue?vue&type=script&setup=true&lang=ts"
export * from "./SingleChart.vue?vue&type=script&setup=true&lang=ts"

import "./SingleChart.vue?vue&type=style&index=0&id=508ca8cb&lang=css"

const __exports__ = script;

export default __exports__